export const isStringValid = (string) => {
	try {
    if(string.replace(/^\s+|\s+$/g, "").length > 0) return true
	}
	catch(e) {
		return false;
	}
	return false;
}





// WEBPACK FOOTER //
// ./src/App/Util/stringValidator.js